import React, { useEffect, useState } from 'react';
import { beneficios as BENEFICIOS } from '../data/contenido';
import { certificacionesPorMarca } from '../services/certificaciones';
import useMedia from '../hooks/useMedia';
import { grande, mini } from '../utils';
import CertCarrusel from './CertCarrusel';
import './AcercaDe.css';

// certificados en orden de marca (Disney, Universal, Destinos, Cruceros) y sus pestañas para el carrusel del celular
const CERTS = certificacionesPorMarca();

export default function AcercaDe() {
  const [abierta, setAbierta] = useState(-1);
  const c = abierta >= 0 ? CERTS.lista[abierta] : null;
  // en el celular los certificados van en un carrusel por marca; en pantallas más anchas, en cuadrícula
  const carrusel = useMedia('(max-width: 599px)');

  useEffect(() => {
    if (!c) return undefined;
    const k = (e) => { if (e.key === 'Escape') setAbierta(-1); };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, [c]);

  return (
    <section id="sobre" className="sobre sec">
      <div className="wrap">
        <div className="sobre__top">
          <div className="sobre__foto" data-reveal>
            <div className="sobre__arco"><img src={grande('images/jenny-perfil.jpg')} alt="Jenny Jiménez Pons" loading="lazy" decoding="async" /></div>
            <div className="sobre__sello"><b>{CERTS.lista.length}</b><span>certificaciones<br />oficiales</span></div>
            <p className="sobre__firma">Jenny Jiménez Pons</p>
          </div>
          <div className="sobre__texto" data-reveal>
            <p className="eyebrow">Sobre mí</p>
            <h2 className="h2 sobre__h2">Un viaje no es un gasto: es una <em>inversión emocional.</em></h2>
            <p className="sobre__p">Diseño viajes que se convierten en recuerdos para toda la vida. Soy agente de viajes por vocación y por pasión. Para mí, cada itinerario es una oportunidad de crear experiencias únicas que conectan a las personas con quienes aman, con el mundo y consigo mismas.</p>
            <p className="sobre__p">Mi prioridad es que cada familia, pareja o viajero individual sienta que hizo la mejor elección al confiar en mí. Estoy en constante preparación, certificándome y actualizándome para ofrecerte un servicio personalizado y a la altura de tus sueños.</p>
            <p className="sobre__p">Diseño cada detalle con cariño, cuidado y honestidad, pensando siempre en lo más importante: que vivas un viaje que valga la pena y que deje huellas bonitas en tu historia.</p>
          </div>
        </div>

        <div className="sobre__bloque">
          <div data-reveal>
            <p className="eyebrow">Reservar conmigo incluye</p>
            <h3 className="h3">Lo que hago por ti, antes y <em>durante</em> tu viaje</h3>
          </div>
          <div className="sobre__benef">
            {BENEFICIOS.map((b) => (
              <div key={b.t} className="card sobre__b" data-reveal>
                <span className="sobre__icon"><i className={b.icon} /></span>
                <h4>{b.t}</h4>
                <p>{b.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="sobre__bloque">
          <div data-reveal>
            <p className="eyebrow">Certificaciones</p>
            <h3 className="h3">Me preparo para que tú viajes <em>tranquilo</em></h3>
          </div>
          {carrusel ? (
            <div data-reveal><CertCarrusel lista={CERTS.lista} grupos={CERTS.grupos} onAbrir={setAbierta} pausado={!!c} /></div>
          ) : (
            <div className="sobre__certs">
              {CERTS.lista.map((ce, i) => (
                <button key={ce.nombre} className="card sobre__cert" onClick={() => setAbierta(i)} data-reveal>
                  <span className="sobre__cert-img"><img src={mini(ce.imagen)} alt={ce.nombre} loading="lazy" decoding="async" /></span>
                  <span className="sobre__cert-n">{ce.nombre}</span>
                  <span className="sobre__cert-a">{ce.fechaInline || ce.fecha}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {c && (
        <div className="modal" onClick={() => setAbierta(-1)} role="dialog" aria-modal="true" aria-label={c.nombre}>
          <div className="modal__box" onClick={(e) => e.stopPropagation()}>
            <button className="modal__x" onClick={() => setAbierta(-1)} aria-label="Cerrar"><i className="fa-solid fa-xmark" /></button>
            <div className="modal__img"><img src={grande(c.imagen)} alt={c.nombre} /></div>
            <p className="eyebrow modal__a">{c.fechaInline || c.fecha}</p>
            <h3 className="modal__t">{c.nombre}</h3>
            <p className="modal__d">{c.em || c.descripcion}</p>
          </div>
        </div>
      )}
    </section>
  );
}
